export { default } from './ProductFeaturesBadges'
